import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    breadcrumbPoint: translate({ id: 'rm.contextual.breadcrumbs.breadcrumbPoint' }),
  }))

  return api
}
